module.exports = __webpack_public_path__ + "img/wans.8324844f.png";